// extracted by mini-css-extract-plugin
export default {"container":"ShowCurrentTeamVisitCheckbox_container__dPSR9"};